import { ForecastVerticalBase } from './base/forecast-vertical-base';

export class ForecastVertical extends ForecastVerticalBase { }